import React, { useState } from 'react';
import styled from 'styled-components';
import { Iphoto } from '../../../models';
import CommonMobileModal from '../../common/CommonMobileModal';
import EditPhotoForm from '../EditPhotoForm';
import moment from 'moment';

interface IProps {
    data: Iphoto[];
    t: any;
    loading: boolean;
    installBaseID: string;
    updatePhoto: any;
    deletePhoto: any;
}

const ListView = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const PhotoContainer = styled.div`
    display: flex;
    gap: 24px;
    flex-direction: row;
    width: 100%;
    padding: 16px;
    border-bottom: 1px solid #dbdcdd;
`;

const ImageCol = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    max-width: 144px;

    & > span {
        height: 40px;
        width: 100%;

        font-style: normal;
        font-weight: 400;
        font-size: 14px;

        /* Blues/Aqua */

        color: #3bb9ea;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

const Image = styled.img`
    border: 1px solid #dbdcdd;
    border-radius: 4px;
`;

const RightCol = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
`;

const ImgSection = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 16px;
`;

const ImgSectionTitle = styled.span`
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #a2acb4;
    padding-bottom: 4px;
`;


export default (props: IProps) => {
    const [selectedPhoto, setSelectedPhoto] = useState<Iphoto | null>(null);

    if (selectedPhoto) {
        return (
            <CommonMobileModal
                show={true}
                onHide={() => {
                    setSelectedPhoto(null);
                }}
                className=""
                title="Edit Image"
            >
                <EditPhotoForm
                    t={props.t}
                    loading={props.loading}
                    installBaseID={props.installBaseID}
                    formValues={selectedPhoto}
                    updatePhoto={props.updatePhoto}
                    deletePhoto={props.deletePhoto}
                    toggleModal={() => setSelectedPhoto(null)}
                    isMobile={true}
                />
            </CommonMobileModal>
        );
    }



    return (
        <ListView>
            {props.data.map((photo: Iphoto, index) => {
                return (
                    <PhotoContainer key={photo.id}>
                        <ImageCol>
                            <Image
                                width="144px"
                                src={
                                    photo.thumbnailImage
                                        ? `data:image/jpeg;base64,${photo.thumbnailImage}`
                                        : photo.thumbnailUrl
                                }
                            />
                            <span
                                onClick={() => {
                                    setSelectedPhoto(photo);
                                }}
                            >
                                Edit Image
                            </span>
                        </ImageCol>
                        <RightCol>
                            <ImgSection>
                                <ImgSectionTitle>Comments</ImgSectionTitle>
                                {photo.comments}
                            </ImgSection>
                            <ImgSection>
                                <ImgSectionTitle>Date Taken</ImgSectionTitle>
                                {moment.utc(photo.createDate).format('MM/DD/YYYY')}
                            </ImgSection>
                            <ImgSection>
                                <ImgSectionTitle>Show in Report</ImgSectionTitle>
                                <span>{photo.isInReport ? props.t('yes') : props.t('no')}</span>
                            </ImgSection>
                        </RightCol>
                    </PhotoContainer>
                );
            })}
        </ListView>
    );
};
